import Nullstack from 'nullstack';
export default function IconHeadset({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-headset",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "13",
    rx: "2",
    width: "4",
    height: "6"
  }), "   ", Nullstack.element("rect", {
    x: "16",
    y: "13",
    rx: "2",
    width: "4",
    height: "6"
  }), "   ", Nullstack.element("path", {
    d: "M4 15v-3a8 8 0 0 1 16 0v3"
  }), "   ", Nullstack.element("path", {
    d: "M18 19a6 3 0 0 1 -6 3"
  }), " ");
}